// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__OkoDL","home":"Header_home__fcU_h"};